<template>
    <div class="page thanks">
        <div class="plane">
            <img src="static/img/plane.png" />
        </div>
        <v-panel>
            <div>
                <h2>Goed gedaan!</h2>
                <p>Je maakt nu {{ correct }}x kans op één van de 4&nbsp;Vakantiepakketten t.w.v.&nbsp;&euro;&nbsp;404,- of een van de 100 hele Staatsloten. We nemen in week 19 persoonlijk contact op met de winnaars.</p>
                <!-- <img class="prijzenpot" src="/static/img/prijzenpot.png" /> -->
                <v-prizevisual></v-prizevisual>
            </div>
            <!-- <p>Wil je <span v-if="!entry.reward">toch</span> alvast meespelen met de trekking van 10 december?</p> -->
            <a slot="button" class="button stl" href="https://loten-staatsloterij.nederlandseloterij.nl/loten" target="_blank" ><span>Koop een Staatslot</span></a>
        </v-panel>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import { TimelineMax } from '@/vendor';
    import Shares from '@/app/components/Shares';
    import Panel from '@/app/components/Panel';
    import PrizeVisual from '@/app/components/PrizeVisual';

    export default {
        components: {
            'v-panel': Panel,
            'v-share': Shares,
            'v-prizevisual': PrizeVisual
        },

        mounted()
        {
            this.$store.dispatch( 'sky', 'light' );
            this.$store.dispatch( 'sun', 'up' );
        },

        computed: {
            entry()
            {
                return this.$store.getters.getEntry;
            },
            correct()
            {
                return this.$store.getters.correct;
            }
        },

        methods:
        {
            getAnimateIn()
            {
                let tl = new TimelineMax();

                tl.from( '.page.thanks', 0.5, { backgroundPositionY: '200px', opacity: 0 });
                tl.from( '.plane', 10, { x: '-100px', ease: Sine.easeOut }, 0 );

                tl.to( '.plane', 7, { y: '20px', repeat: -1, yoyo: true, ease: Sine.easeInOut }, 5 );
                tl.to( '.plane', 10, { x: '-20px', repeat: -1, yoyo: true, ease: Sine.easeInOut }, 11 );

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Thanks.vue